import { useContext } from 'react';
import { AuthenticationContext } from '../context/AuthenticationProvider.js';
const useNavigate = () => {
  const context = useContext(AuthenticationContext);
  const externalNavigate = path => {
    if (typeof path === "string") {
      window.location.href = path;
    } else {
      const {
        pathname = "",
        hash = "",
        search = ""
      } = path;
      window.location.href = pathname + search + hash;
    }
  };
  return context.config.onNavigate || externalNavigate;
};
export { useNavigate as default, useNavigate };